import { render } from "./CCQuery.vue?vue&type=template&id=f2b12530&scoped=true"
import script from "./CCQuery.vue?vue&type=script&lang=js"
export * from "./CCQuery.vue?vue&type=script&lang=js"

import "./CCQuery.vue?vue&type=style&index=0&id=f2b12530&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2b12530"

export default script